export const USERS = {
    login: "login",
}

export const VENTAS = {
    ventas: "ventas/apiVentas.php"
}

export const COMISIONES = {
    comisiones: "compras/apiCompras.php"
}

export const ORDENES = {
    ordenes: "ordenes/get_ordenes.php",
    disponibilidad: "ordenes/apiDisponibilidadOrden.php",
}

export const ALMACEN = {
    almacen_id: "almacen/api_productos_id.php",
    almacen: "almacen/api_productos.php",
}

export const INYECCION = {
    inyeccion: "inyeccion/api_operador_inyeccion.php",
}

export const REGISTRAREMPRESA = {
    empresa: "registrarEmpresa",
    getRegistros: "getEmpresasRegistros",
};